import { render, staticRenderFns } from "./my-contact.vue?vue&type=template&id=589e21fc&scoped=true&"
import script from "./my-contact.vue?vue&type=script&lang=js&"
export * from "./my-contact.vue?vue&type=script&lang=js&"
import style0 from "./my-contact.vue?vue&type=style&index=0&id=589e21fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e21fc",
  null
  
)

export default component.exports